(() => {
  if (window.videliOliverLinksReady) return;
  window.videliOliverLinksReady = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-oliver-link]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const target = new URL(link.href, location.href);
    const bot = document.querySelector('videli-oliver');
    if (!bot || typeof bot.open !== 'function' || target.origin !== location.origin) return;
    if (link.dataset.destination === 'custom' && target.pathname !== location.pathname) return;
    event.preventDefault(); bot.open();
  });
})();
